import React, {ReactNode} from 'react';
import styled from 'styled-components';

import {isDefined} from '../../../../../../../../libs/shared/core/src/helpers/typescript/typeHelpers';
import {DropdownBoxCoordinator} from '../../../../../../../../libs/shared/ui/src/components/boxedInputs/dropdownBoxCoordinator';
import {PopoverTransferProps} from '../../../../../../../../libs/shared/ui/src/components/popovers/popoverCoordinator';
import {StyledMacroInputDescriptionDiv} from './macroInputDropdownStyles';
import {MacroInputReadonlyCommonProps} from './macroInputTypes';

/*
 * Props.
 */

interface MacroInputDropdownBoxCoordinatorProps<T> extends MacroInputReadonlyCommonProps<T> {
  renderValue: (value: T) => ReactNode;
  renderDropdown: (popoverTransferProps: PopoverTransferProps) => ReactNode;
  placeholder: ReactNode;
}

/*
 * Style.
 */

const StyledPlaceholderSpan = styled.span`
  color: ${({theme}) => theme.composerPlaceholder};
`;

const StyledDropdownBoxCoordinator = styled(DropdownBoxCoordinator)`
  width: fit-content;
  overflow: hidden;
  max-width: 100%;
`;

/*
 * Component.
 */

export const MacroInputDropdownBoxCoordinator = <T,>({
  value,
  description,
  label,
  placeholder,
  renderValue,
  renderDropdown,
}: MacroInputDropdownBoxCoordinatorProps<T>) => (
  <StyledDropdownBoxCoordinator
    boxStyles={{width: 'fit-content'}}
    value={
      isDefined(value) ? renderValue(value) : <StyledPlaceholderSpan>{placeholder}</StyledPlaceholderSpan>
    }
    renderDropdown={renderDropdown}
    label={label}
    message={<StyledMacroInputDescriptionDiv>{description}</StyledMacroInputDescriptionDiv>}
    noMargin
    shouldDisablePadding
    shouldDisableBottomTextMargin
    isRequired
  />
);
